module.exports = __webpack_public_path__ + "img/popup-icon.804e82cf.svg";